import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Calendar from '../../../../../components/Calendar';
import './OffDays.scss';
import {Button, buttonTypes} from "../../../../../components/Button";


const OffDays = (props) => {
  const {
    offTourDates,
    onNewDate,
  } = props;

  const currentDate = (e) => {
    for (let i = 0; i < offTourDates.length; i++) {
      if (offTourDates[i] === e) {
        offTourDates.splice(i, 1);
        return onNewDate(offTourDates)
      }
    }
    offTourDates.push(e);
    return onNewDate(offTourDates)
  };

  const deleteDate = (index) => {
    offTourDates.splice(index, 1);
    return onNewDate(offTourDates)
  };

  const getSelectedDates = (dates) => {
    const result = [];
    for (let i = 0; i < dates.length; i++) {
      const date = dates[i].split('-');
      result.push(
        <li
          className="off-days__list-item"
          key={`off-days-${dates[i]}`}
        >
          <Button
            type={buttonTypes.LINK}
            className="button__icon ion-close-round"
            onClick={() => deleteDate(i)}
          />
          <p className="off-days__this-date">{`${date[2]} ${moment(dates[i]).format('MMMM')} ${date[0]}`}</p>
        </li>
      )
    }
    return result;
  };


  const calendarSettings = {
    locale: 'en',
    isISO: true,
    returnCurrentMonth: () => {
    },
    returnThisDate: currentDate,

    myEvents: offTourDates || [],
    events: [],
  };

  return (
    <div className="off-days">
      <h3 className="off-days__title">Blackout days</h3>
      <div className="off-days__body">
        <Calendar
          {...calendarSettings}
        />
        <ul className="off-days__list scroll">
          {getSelectedDates(offTourDates || [])}
        </ul>
      </div>
    </div>
  )
};

OffDays.propTypes = {
  offTourDates: PropTypes.array,
  onNewDate: PropTypes.func,
};

export default OffDays;


// WEBPACK FOOTER //
// ./src/app/containers/Vendor/Tour/components/OffDays/index.js